import { ACTIONS } from "../../common/constants";

const scmHeaderDataReducer = function (
  state = { circle: "", cart: [], circles: [] },
  action
) {
  switch (action.type) {
    case ACTIONS.SET_CIRCLE:
      return { ...state, circle: action.data };
    case ACTIONS.SET_CIRCLE_OPTIONS:
      return { ...state, circles: action.data };
    case ACTIONS.SET_SCM_CART:
      return { ...state, cart: action.data };
    default:
      return state;
  }
};

export default scmHeaderDataReducer;
